import styles from "./product.module.css";
import { forwardRef, useState, useEffect } from "react";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { HeadingTitle, Image } from "../../../shared/index";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../../../lib/get-image";
import toast from "react-hot-toast";

import authService from "../../../../services/authService";

import {
  useAddToWishList,
  useRemoveWishList,
} from "../../../../queries/useWishListQuery";

import {
  useAddToCart,
  useIncreaseCartQty,
  useDecreaseCartQty,
  useGetCart,
} from "../../../../queries/useCartQuery";

const Product = forwardRef(
  ({ product, wishItems, isWishListPending }, ref) => {
    const { id, name, slug, thumb_image, price, offer_price } =
      product;

    const isLoggedIn = authService.isLoggedIn();

    /** CART */
    const { data: cartItems = [] } = useGetCart();
    const { mutate: addToCart, isPending: isAdding } = useAddToCart();
    const { mutate: increaseQty } = useIncreaseCartQty();
    const { mutate: decreaseQty } = useDecreaseCartQty();
const maxQty = product?.qty || 0;
    const cartItem = cartItems?.find(
      (item) => item.product_id === id
    );

    const isInCart = Boolean(cartItem);

    /** ❤️ WISHLIST */
    const { mutate: addWish } = useAddToWishList();
    const { mutate: removeWish } = useRemoveWishList();

    const wishItem = wishItems?.find(
      (w) => w.product_id === id
    );

    const inWishList = Boolean(wishItem);
    const wishlistId = wishItem?.id;

    const handleWishlist = (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (inWishList) removeWish(wishlistId);
      else addWish({ product_id: id });
    };

    /** 💰 PRICE */
    const originalPrice = Number(price) || 0;
    const offerPrice = Number(offer_price) || 0;

    const hasOffer =
      offerPrice > 0 && offerPrice < originalPrice;

    const finalPrice = hasOffer
      ? offerPrice
      : originalPrice;


 const discountPercent =
  hasOffer
    ? Math.round(((originalPrice - offerPrice) / originalPrice) * 100)
    : 0;     
    /** QTY (LOCAL STATE) */
    const [quantity, setQuantity] = useState(1);

    useEffect(() => {
      setQuantity(1);
    }, [id]);

    /** ➕ INCREASE */
    const handleIncrease = (e) => {
      e.stopPropagation();

      if (!isLoggedIn) {
        toast.error("Please login first");
        return;
      }

    setQuantity((prev) => {
  if (prev >= maxQty) return prev;
  return prev + 1;
});
    };

    /** ➖ DECREASE */
    const handleDecrease = (e) => {
      e.stopPropagation();

      if (!isLoggedIn) {
        toast.error(" Please login first");
        return;
      }

      setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
    };

    /** 🛒 ADD TO CART */
    const handleAddToCart = (e) => {
      e.stopPropagation();

      if (!isLoggedIn) {
        toast.error(" Please login first");
        return;
      }

      if (isInCart) {
        toast.error("Already in cart");
        return;
      } 

      addToCart(
        {
          product_id: id,
          quantity: quantity,
        },
        {
          onSuccess: () => {
            toast.success("Item added to cart 🛒");
          },
        }
      );
    };

    return (
      <div ref={ref} className={styles.productCard}>
        {/* IMAGE */}
        <Link to={`/productdetails/${slug}`}>
          <div className={styles.productImageWrapper}>
            <button
              className={styles.wishlistButton}
              onClick={handleWishlist}
              disabled={isWishListPending}
            >
              {inWishList ? (
                <FaHeart size={22} color="#e53935" />
              ) : (
                <CiHeart size={22} color="#444" />
              )}
            </button>

            <Image
              src={getImageUrl(thumb_image)}
              alt={name}
              className={styles.productImage}
            />
          </div>

          <div className={styles.productInfo}>
            <HeadingTitle
              text={name}
              style={styles.productName}
            />
          </div>
        </Link>

        {/* PRICE */}
<div className={styles.priceWrapper}>
  <div className={styles.priceBlock}>

    <div className={styles.priceRow}>
      <p className={styles.productPrice}>
        <LiaRupeeSignSolid />
        {finalPrice}
      </p>

      {hasOffer && (
        <p className={styles.originalPrice}>
          <LiaRupeeSignSolid />
          {originalPrice}
        </p>
      )}

      {hasOffer && (
        <span className={styles.discountTextRight}>
          {discountPercent}% OFF
        </span>
      )}
    </div>

  </div>
</div>

        {/* CART UI */}
        <div className={styles.cartSection}>
          <div className={styles.qtyBox}>
            <div className={styles.qtyValue}>
              {quantity}
            </div>

            <div className={styles.qtyArrows}>
             <button
  className={styles.arrowBtn}
  onClick={handleIncrease}
  disabled={quantity >= maxQty}
>
  ▲
</button>

              <button
                className={styles.arrowBtn}
                onClick={handleDecrease}
              >
                ▼
              </button>
            </div>
          </div>

        <button
  className={styles.addToCartBtn}
  onClick={handleAddToCart}
  disabled={isAdding || isInCart}
>
  {isInCart
    ? "Add To Cart 🛒"
    : isAdding
    ? "Adding..."
    : "Add To Cart 🛒"}
</button>
        </div>
      </div>
    );
  }
);

export default Product;